module.exports = __webpack_public_path__ + "static/media/youtubeIcon.62f278a2.png";